module.exports = __webpack_public_path__ + "img/bbva-branch.d4748f7a.png";